import { API_BASE_URL } from "../apiConfig";
import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "../context/LocationContext";
import "./UserDashboard.css"; // Reuse existing styles for consistency

const DriverDashboard = () => {
  const { locationStatus } = useLocation();
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState({
    totalAssigned: 0,
    completedComplaints: 0,
    pendingComplaints: 0
  });
  const [loading, setLoading] = useState(true);

  // Sync user state
  useEffect(() => {
    const syncUser = () => {
      const sessionStored = sessionStorage.getItem("currentUser");
      if (sessionStored) {
        const parsed = JSON.parse(sessionStored);
        if (parsed.role === "driver") setUser(parsed);
      }
    };
    syncUser();
  }, []);

  const fetchDriverStats = useCallback(async () => {
    if (!user?.username) return;
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/complaint/driver-stats/${user.username}`);
      if (!response.ok) throw new Error("Failed to fetch stats");
      const data = await response.json();
      setStats({
        totalAssigned: data.totalAssigned || 0,
        completedComplaints: data.completedComplaints || 0,
        pendingComplaints: data.pendingComplaints || 0
      });
    } catch (err) {
      console.error("Error fetching driver stats:", err);
    } finally {
      setLoading(false);
    }
  }, [user?.username]);


  useEffect(() => {
    if (user?.username) {
      fetchDriverStats();
    }
  }, [user?.username, fetchDriverStats]);

  if (!user || loading) return <div className="user-dashboard loading"><div className="loading-spinner">Loading dashboard...</div></div>;

  return (
    <div className="user-dashboard">
      <div className="dashboard-header">
        <div className="welcome">
          <h1>Welcome, {user.username}! 🚛</h1>
          <p>Here is your assignment overview for today.</p>
        </div>
        
        <div className="location-card">
          <div className="location-icon">📍</div>
          <div className="location-info">
            <span className="label">Live Location</span>
            <span className={`status ${locationStatus.includes("✅") ? "online" : "offline"}`}>
              {locationStatus}
            </span>
          </div>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card total">
          <div className="icon">📂</div>
          <div>
            <h3>Total Assigned</h3>
            <h2>{stats.totalAssigned}</h2>
            <p>All tasks assigned to you</p>
          </div>
        </div>

        <div className="stat-card completed">
          <div className="icon">✅</div>
          <div>
            <h3>Completed</h3>
            <h2>{stats.completedComplaints}</h2>
            <p>Tasks you have finished</p>
          </div>
        </div>

        <div className="stat-card pending">
          <div className="icon">⏳</div>
          <div>
            <h3>Pending</h3>
            <h2>{stats.pendingComplaints}</h2>
            <p>Ongoing assignments</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverDashboard;
